export default "__VITE_ASSET__Dhb_jWJW__"